import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColEllipsisOpen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
			fill: "#CFD8DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9375 11.75C15.9375 12.4883 16.5117 13.0625 17.25 13.0625C17.9609 13.0625 18.5625 12.4883 18.5625 11.75C18.5625 11.0391 17.9609 10.4375 17.25 10.4375C16.5117 10.4375 15.9375 11.0391 15.9375 11.75ZM8.0625 11.75C8.0625 11.0391 7.46094 10.4375 6.75 10.4375C6.01172 10.4375 5.4375 11.0391 5.4375 11.75C5.4375 12.4883 6.01172 13.0625 6.75 13.0625C7.46094 13.0625 8.0625 12.4883 8.0625 11.75ZM13.3125 11.75C13.3125 11.0391 12.7109 10.4375 12 10.4375C11.2617 10.4375 10.6875 11.0391 10.6875 11.75C10.6875 12.4883 11.2617 13.0625 12 13.0625C12.7109 13.0625 13.3125 12.4883 13.3125 11.75Z",
			fill: "#607D8B"
		})
	]
});
const ForwardRef = forwardRef(SvgColEllipsisOpen);
export { ForwardRef as ReactComponent };
